import { createFileRoute } from "@tanstack/react-router";
import { CollectionScreen } from "@/features/assets/components/CollectionScreen";
import { collectionQuery } from "@/features/assets/queries";
import { sessionQuery } from "@/features/auth/queries";

export const Route = createFileRoute("/_authenticated/assets/collections/$collectionId")({
  loader: ({ context: { queryClient }, params: { collectionId } }) => {
    void queryClient
      .ensureQueryData(sessionQuery)
      .then(session =>
        queryClient.prefetchQuery(collectionQuery(collectionId, session?.user.id ?? null)),
      )
      .catch(() => undefined);
  },
  head: () => ({ meta: [{ title: "Collection · Pax.co" }] }),
  component: CollectionPage,
});

function CollectionPage() {
  const { collectionId } = Route.useParams();
  return <CollectionScreen key={collectionId} collectionId={collectionId} />;
}
